export const UMOL_PER_L_TO_MG_PER_DL = 88.4;

// Pure Cockcroft-Gault: returns mL/min as a number, or null on invalid input.
// Reference: Cockcroft DW, Gault MH. Nephron 1976;16:31-41.
//   CrCl (mL/min) = ((140 - age) * weightKg) / (72 * Scr_mg/dL); * 0.85 if Female.
// scrUnit: 'umol/L' | 'mg/dL'. gender: 'Male' | 'Female'.
export function calculateCrCl({ ageYears, weightKg, serumCreatinine, scrUnit, gender }) {
  const age = parseFloat(ageYears);
  const weight = parseFloat(weightKg);
  const scr = parseFloat(serumCreatinine);
  if (gender !== 'Male' && gender !== 'Female') return null;
  if (!isFinite(age) || !isFinite(weight) || !isFinite(scr)) return null;
  if (age <= 0 || weight <= 0 || scr <= 0) return null;
  const scrMgDl = scrUnit === 'umol/L' ? scr / UMOL_PER_L_TO_MG_PER_DL : scr;
  if (scrMgDl <= 0) return null;
  let crcl = ((140 - age) * weight) / (72 * scrMgDl);
  if (gender === 'Female') crcl *= 0.85;
  if (!isFinite(crcl) || crcl < 0) return null;
  return crcl;
}
